export const userProfile = {
  forgottenPassword: {
    passwordResetEmailSent: 'A password reset email has been sent to your email address.',
  },
};
